import React from 'react';
import styled from 'styled-components';
// Components
import B2BBox from '../Elements/B2BBox';
// Assets
import HotelB2B from '../../assets/img/hotelB2B.jpg';
import PrivateSector from '../../assets/img/privateSector.jpg';
import Technopole from '../../assets/img/technopole.png';
import { Link } from 'react-scroll';

import { useTranslation } from 'react-i18next';

export default function B2B() {
    const { t } = useTranslation();

    return (
        <Wrapper id="b2b">
            <div className="whiteBg">
                <div className="container">
                    <HeaderInfo>
                        <h1 className="font40 extraBold"> {t('titleIntegratingSectors1')} </h1>
                        <Text>
                            <p className="font18 semiBold">{t('titleIntegratingSectors2')}</p>
                        </Text>
                    </HeaderInfo>
                    <div className="row textCenter">
                        <div className="col-xs-12 col-sm-4 col-md-4 col-lg-4">
                            <B2BBox
                                img={PrivateSector}
                                title={t('titlePublicPrivateSectors')}
                                text={t('textPublicPrivateSectors')}
                            />
                        </div>
                        <div className="col-xs-12 col-sm-4 col-md-4 col-lg-4">
                            <B2BBox img={HotelB2B} title={t('titleHotelsResorts')} text={t('textHotelsResorts')} />
                        </div>
                        <div className="col-xs-12 col-sm-4 col-md-4 col-lg-4">
                            <B2BBox
                                img={Technopole}
                                title={t('titleTechnologyHubsCampuses')}
                                text={t('textTechnologyHubsCampuses')}
                            />
                        </div>
                    </div>
                    <div className="textCenter">
                        <Link className="animate radius8 ButtonInput semiBold pointer" smooth={true} to="contact">
                            {t('getInTouch')}
                        </Link>
                    </div>
                </div>
            </div>
        </Wrapper>
    );
}

const Wrapper = styled.section`
    width: 100%;
`;
const HeaderInfo = styled.div`
    @media (max-width: 860px) {
        text-align: center;
    }
`;

const Text = styled.div`
    padding: 15px 0 15px 0;
    line-height: 1.5rem;
    @media (max-width: 970px) {
        padding: 15px 0 50px 0;
        text-align: center;
        max-width: 100%;
    }
`;
